import { render, staticRenderFns } from "./CardQuestion.vue?vue&type=template&id=38dba619&scoped=true&"
import script from "./CardQuestion.vue?vue&type=script&lang=js&"
export * from "./CardQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CardQuestion.vue?vue&type=style&index=0&id=38dba619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dba619",
  null
  
)

export default component.exports